/* eslint-disable no-loop-func */
import React, { useEffect, useState } from "react";
import { Button, BUTTON_VARIANTS,Loader, Link, LINK_ICON_POSITIONS, IconOpenInNew, IconCheckCircle, StatusIndicator, Divider } from 'cdk-radial';
import '../styles/addendums.scss';
import { useSelector } from "react-redux"
import ConsentAccordion from '../ConsentAccordion';


const COLOR_STROKE = '#006CFA';
const DARK_GREEN = 'rgb(9, 173, 0)';
const LIGHT_GREEN = 'rgb(205, 240, 204)';
const DARK_GRAY = 'rgb(169, 169, 169)';
const LIGHT_GRAY = 'rgb(211, 211, 211)';

const LOADER_STYLE = {
  stroke: COLOR_STROKE,
  margin: '0px 70px',
  display: 'flex'
};

export const ClubbedApis = (props) => {

    const {
        apis,
        isAddendumsAccepted,
        isCustomConesentApi,
        isNoAddendum,
        onReviewTerms,
        isDataRightsAccepted,
        consentDetails,
        doesAppRequireDataRights,
        addendumsAccepted,
        loadingStatus,
        customConsentFormSignedS3Url,
        consentInfo
    } = props;

    const {
        selectLocationsSlice,
    } = useSelector(state => state);

    const {isCheckAddendumsSignedPending, checkAddendumsErroredEntityIds} = selectLocationsSlice;
    const [loading, setLoading] = useState();
    const [isAccepted, setIsAccepted] = useState();
    const [addendumDoc, setAddendumDoc] = useState();
    const [disabled, setDisabed] = useState();

    useEffect(()=>{
        if(doesAppRequireDataRights && !isDataRightsAccepted) {
            setDisabed(true)
        } else {
            setDisabed(false)
        }
    },[doesAppRequireDataRights,  isDataRightsAccepted])

    useEffect(() => {
        if(isAccepted && apis && apis.length){
            if(isCustomConesentApi){
                setAddendumDoc([customConsentFormSignedS3Url]);
            } else {
                let consents = [];
                let isOneClick = false; 
                for(const key in consentInfo) {
                    key && consentInfo[key].addendumsAccepted && consentInfo[key].addendumsAccepted.map(addendum => {
                        if(addendum.apiProviderId === apis[0].id){
                            if (addendum.signedTermsAndConditions) {
                                consents.push(addendum.signedTermsAndConditions);
                              } else {
                                isOneClick = true;
                                consents.push(addendum.documentLink);
                              }
                        }
                    });
                    if(isOneClick){
                        break;
                    }
                }
                setAddendumDoc(consents)
            }
        }
    }, [isAccepted, consentInfo, apis]);
    
    useEffect(()=>{
        if(addendumsAccepted.length) {
            let apiIds = apis.map((api)=>api.id)
            const flag = apiIds.every((val)=> {
            if(addendumsAccepted.indexOf(val) >= 0){
                return true;
            }
            return false;
            });
            setIsAccepted(flag)
        } else {
            setIsAccepted(false)
        }
    },[addendumsAccepted]);

    useEffect(()=>{
        if(loadingStatus || isCheckAddendumsSignedPending)
            setLoading(true)
        else setLoading(false)
    }, [isCheckAddendumsSignedPending, loadingStatus])


    const onReviewTerm = () => {
        onReviewTerms(
            apis,
            isAddendumsAccepted,
            isCustomConesentApi,
            isNoAddendum,
        )
    }

    const openMultipleConsents=(consents)=>{
        for(const url of consents)
        {
          window.open(url,'_blank')
        }
      }

    return (
        <div>
            {
                apis.map((api, index) => (
                    <div>
                    <div
                        key={api && api.id}
                        className="addendums-body"
                    >
                        <div className="addendums-body-app-publisher">
                            {
                                !loading && !isNoAddendum && isAccepted ? 
                                    <div>
                                        <span className="addendums-body-clickable-app-name" onClick={()=>openMultipleConsents(addendumDoc)}>
                                            {api && api.productName}
                                            <Link
                                                icon={<IconOpenInNew height="14" width="14" />}
                                                iconPosition={LINK_ICON_POSITIONS.LEADING}
                                            />
                                        </span>
                                        view agreement 
                                    </div>
                                    :
                                    <div className="addendums-body-app-name">
                                        {api && api.productName}
                                    </div>
                            }
                            <div className="addendums-body-app-publisher">
                                By: {api && api.name}
                            </div>
                        </div>
                        <div>
                        {index === apis.length-1 && 
                            <div className='addendums-body-review-terms-container'>
                                <div className="addendums-body-review-terms">
                                    {
                                        checkAddendumsErroredEntityIds?.length ?
                                            <StatusIndicator
                                                backgroundColor={LIGHT_GRAY}
                                                borderColor={DARK_GRAY}
                                                iconColor={DARK_GREEN}
                                                label="Failed to load data"
                                                variant="custom"
                                            />
                                        :
                                        isAccepted && !loading
                                            ? (
                                                <div className='accepted-addendums'>
                                                <div className='status-tag'>
                                                    <StatusIndicator
                                                    backgroundColor={LIGHT_GREEN}
                                                    borderColor={DARK_GREEN}
                                                    icon={<IconCheckCircle />}
                                                    iconColor={DARK_GREEN}
                                                    label="Terms accepted"
                                                    variant="custom"
                                                    />
                                                </div>
                                                </div>
                                            ) 
                                            : loading ? 
                                            (<Loader style={LOADER_STYLE} />)
                                            : <Button
                                            backgroundAppearance="light"
                                            customTagElement=""
                                            dataTestId="button"
                                            hideText={false}
                                            iconClassName=""
                                            iconColor="primary"
                                            iconSize={28}
                                            isDisabled={disabled}
                                            isLoading={false}
                                            loaderText="Loading..."
                                            onClick={event =>onReviewTerm()}
                                            onKeyDown={function noRefCheck() {}}
                                            preserveClickableArea={false}
                                            size="standard"
                                            icon={<IconOpenInNew />}
                                            text={isNoAddendum ? "Accept terms" :"Review Terms"}
                                            type=""
                                            variant={BUTTON_VARIANTS.SECONDARY}
                                        />
                                    }
                                
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    {
                        index === apis.length-1 &&  
                        <div>
                            {
                                isAccepted && consentDetails && !loading
                                ?  Object.values(consentDetails).map(item => (
                                    item[0].apiProviderId === api.id
                                        ? <div className='consent-details-tag'><ConsentAccordion data={item}/></div>
                                        :null
                                    ))
                                : null

                            }
                        </div>
                    }
                    </div>
                ))
            }
        </div>
    )

}